<template>
  <div class="home">
    <ShortPresen :InfoView="IberoPresen" :TitleRef="$ml.get('txtIberoPresen')"/>
    <ShortVitual :InfoView="IberoVirtual" :TitleRef="$ml.get('txtIberoVitual')"/>         
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import ShortVitual from '@/components/Shortcuts.vue'
  import ShortPresen from '@/components/Shortcuts.vue'

  export default {  
    name: 'home',
    components:{
      ShortVitual,
      ShortPresen
    },
    computed: {
      ...mapState(['IberoPresen','IberoVirtual'])
    }
  }
</script>

<style>
  *
  {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html
  {
    font-size: 62.5%;
  }

  body
  {
    font-size: 1.6rem;
  }

  .home {
    padding: 0rem 0rem;
  }
  
  @media (max-width: 980px) {
    .home {
      padding-left: 10%;
      padding-right: 10%;
    }
  }

  @media (max-width: 580px) {
    .home {
      padding-left: 1%;
      padding-right: 1%;
    }
  }

  .nav-link
  {
    color: #000;
  }
</style>